// Pathfinder Unchained Variant Multiclassing — Ranger archetype benefit tiers.
const rangerArchetype = [
	{
		level: 3,
		name: 'Track',
		description: 'You gain the track class feature, treating your character level as your effective ranger level.',
	},
	{
		level: 7,
		name: 'Favored Enemy',
		description: 'You gain your 1st favored enemy class feature.',
	},
	{
		level: 11,
		name: 'Favored Terrain',
		description: 'You gain your 1st favored terrain class feature.',
	},
	{
		level: 15,
		name: 'Expert Tracker',
		description: 'You gain the woodland stride and swift tracker class features.',
	},
	{
		level: 19,
		name: 'Quarry',
		description: 'You gain the quarry class feature.',
	},
];

export default rangerArchetype;
